import(/* webpackMode: "eager", webpackExports: ["ResetPasswordPage"] */ "/home/runner/work/33m2-front/33m2-front/src/pages/reset-password/ui/page.tsx");
